import { FC } from "react";

import { NumberInput, Row, Select } from "@hightouch/htui";

import {
  DEFAULT_EXPIRE_AFTER,
  EXPIRE_AFTER_TIME_OPTIONS,
  type ExpireAfter,
  minQuantityForUnit,
} from "src/components/journey/expire-after";
import { IntervalUnit } from "src/types/visual";

type Props = {
  value: ExpireAfter | null | undefined;
  onChange: (value: ExpireAfter) => void;
  isDisabled?: boolean;
};

export const ExpireAfterInput: FC<Props> = ({
  value,
  onChange,
  isDisabled,
}) => (
  <Row align="center" gap={2}>
    <NumberInput
      aria-label="Expiry quantity"
      isDisabled={isDisabled}
      placeholder="Select quantity…"
      value={value?.quantity}
      width="auto"
      onChange={(quantity) => {
        const unit = value?.unit ?? DEFAULT_EXPIRE_AFTER.unit;
        // The floor is applied here rather than through NumberInput's `min`,
        // which snaps the controlled value before it reaches state: the box
        // renders the floor while the form still holds the lower number, and
        // re-typing the floor is then a no-op, so the field cannot be fixed.
        onChange({
          unit,
          quantity: Math.max(quantity ?? 0, minQuantityForUnit(unit)),
        });
      }}
    />
    <Select
      aria-label="Expiry unit"
      isDisabled={isDisabled}
      placeholder="Select unit…"
      options={EXPIRE_AFTER_TIME_OPTIONS}
      value={value?.unit}
      width="auto"
      onChange={(rawUnit) => {
        const unit = rawUnit as IntervalUnit;
        const quantity = value?.quantity ?? DEFAULT_EXPIRE_AFTER.quantity;
        // Switching Day -> Hour can drop a valid quantity under the floor.
        onChange({
          unit,
          quantity: Math.max(quantity, minQuantityForUnit(unit)),
        });
      }}
    />
  </Row>
);
